// extracted by css-extract-rspack-plugin
export default {"stagesTabs":"StagesTabs_stagesTabs__90+3S"};